module.exports = __webpack_public_path__ + "0-cdc27524.worker.js"